// extracted by mini-css-extract-plugin
export default {"wraper":"ForgotPassword_wraper__OkCKP","box":"ForgotPassword_box__olZ4v","show":"ForgotPassword_show__QhmS5","time":"ForgotPassword_time__DFRoO"};